import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GetJobId from "../../../_utilities/GetJobId";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import {
  GetUserId,
  GetUserInfo,
  getAttributes,
  getUserDetails,
} from "../../../_utilities/getUserInfo";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
import { openDocumentInNewTab } from "../../../_utilities/utilities";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import {
  Box,
  Button,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";
import AddApplicantDocuments from "./AddApplicantDocuments";

import "./ApplicantDocuments.css";

const initalState = { data: null, message: "", isloader: true };

const ApplicantDocuments = () => {
  const dispatch = useDispatch();
  const [documents, setDocuments] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [HandlerType, setHandlerType] = useState("");
  const [previewType, setPreviewType] = useState("");
  const [actionType, setActionType] = useState("");
  const [isValidUser, setIsValidUser] = useState(false);

  const [isLoadDoc, setIsLoadDoc] = useState(false);
  const [config, setConfig] = useState(configuration);
  const [docObj, setDocObj] = useState("");
  const [open, setOpen] = useState(false);
  const [fileExtention, setFileExtention] = useState("");

  const JobId = GetJobId();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (JobId !== null) {
      FetchDoc();
    }
  }, [JobId]);

  useEffect(() => {
    if (isLoadDoc === true && JobId !== null) {
      FetchDoc();
      setIsLoadDoc(false);
    }
  }, [isLoadDoc]);

  const GetDocumentsdata = useSelector((state) => state.GetDocuments.data);
  const GetDocumentscode = useSelector((state) => state.GetDocuments.code);
  const updateResumeData = useSelector((store) => store.UploadResume);

  useEffect(() => {
    if (GetDocumentscode === 404) {
      setIsValidUser(true);
      setConfig((prev) => ({ ...prev, isDropdownActions: false }));
    }
  }, [GetDocumentscode]);

  const FetchDoc = async () => {
    setDocuments([]);
    dispatch(_ser.getDocumentsAsync(JobId));
  };

  const DocId = useSelector((state) => state.UploadDocuments.docId);
  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );

  useEffect(() => {
    async function processApplicantjobs() {
      if (
        DocId &&
        !location.state?.isAssociatedApplicant &&
        selectedJobDetails?.length > 0
      ) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();

        let data = {
          id: JobId,
          jobCode: selectedJobDetails[0].jobCode,
          docId: DocId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(_ser.addAssociatedjobsAsync(JobId, data, "posting"));
        dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));

        dispatch(_ser.uploadDocumentsStartReducer(initalState));
      }
    }
    processApplicantjobs();
  }, [DocId]);

  useEffect(() => {
    if (GetDocumentsdata !== null) {
      let docData = JSON.parse(JSON.stringify(GetDocumentsdata));
      if (docData.length > 0) {
        docData.forEach((list) => {
          list.name = list.name.replaceAll("-", " ");
          list.createdDate = GetTimeZone(list.createdDate);
          list["total_count"] = docData.length;
          list["uploadedBy"] =
            (list.firstName ? list.firstName : "") +
            " " +
            (list.lastName ? list.lastName : "");
        });
        let configure = JSON.parse(JSON.stringify(config));
        configure.totalRecords = docData.length;
        configure.currentPage = 1;
        setConfig(configure);
        setDocuments(docData);
        dispatch(_ser.getDocumentsStartReducer(initalState));
      } else {
        setDocuments([]);
      }
    }
  }, [GetDocumentsdata]);

  const onReceiveActionHandler = async (type, object) => {
    if (type === "confirmDel") {
      DeleteDocuments(object);
    } else if (
      type === "Download" ||
      type === "download" ||
      type === "viewDocumentNewPage"
    ) {
      DownloadFileFromS3(object, type);
    } else if (type === "view") {
      DownloadFileFromS3(object, type);
      setHandlerType(type);
      setIsRightSidePannel(true);
    } else if (type === "New Document") {
      setIsRightSidePannel(true);
      setHandlerType("New document");
    } else if (type === "Mark as Primary") {
      setOpen(true);
      setDocObj(object[0]);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActionClick = (data, type) => {
    if (type === "confirm") {
      markPrimaryHandler(docObj);
    }
  };

  const markPrimaryHandler = async (docObj) => {
    const userInfo = await getUserDetails();
    const customerId = await GetUserId();
    let formData = new FormData();
    formData.append("customerId", customerId);
    formData.append("userId", userInfo.userId);
    formData.append("docId", docObj.id);
    dispatch(_ser.uploadResumeAsync(formData, true));
  };

  useEffect(() => {
    if (updateResumeData.code === 209 && updateResumeData.updatedata) {
      let obj = { ...updateResumeData.updatedata[0] };
      obj["message"] = updateResumeData.message;
      obj["id"] = updateResumeData.id;
      obj["oldApplicantName"] = updateResumeData.oldApplicantName;
      dispatch(_ser.uploadResumeStartReducer(initalState));
      navigate(`/ats/layout/applicants/edit/${updateResumeData.id}`, {
        state: { applicant: obj, docId: docObj.id, isOverwriteEdit: true },
      });
    } else if (updateResumeData.code === 210) {
      setOpen(false);
      dispatch(
        updateSnackbar({ type: "error", message: updateResumeData.message }),
      );
      let data = [...documents];
      data.forEach((list) => {
        list["isChecked"] = false;
      });
      setDocuments(data);
      dispatch(_ser.uploadResumeStartReducer(initalState));
    }
  }, [updateResumeData]);

  const code = useSelector((state) => state.DeleteDocuments.data);

  const DeleteDocuments = async (object) => {
    let obj = { file_ids: [object.id.toString()] };
    dispatch(_ser.deleteDocumentsAsync(JobId, obj));
  };

  useEffect(() => {
    if (code === 200) {
      FetchDoc();
      dispatch(_ser.deleteDocumentsStartReducer(initalState));
    }
  }, [code]);

  const docData = useSelector((state) => state.Downloaddocument.data);
  const [DocName, setDocName] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);

  const DownloadFileFromS3 = async (object, type) => {
    const actiontypeToApi =
      type === "Download" || type === "download" ? "download" : "preview";
    const actiontype =
      type === "Download" || type === "download"
        ? "download"
        : type === "view"
          ? "preview"
          : type;
    setSelectedDoc(object);
    setActionType(actiontype);
    setDocName(object.path);
    setFileExtention(object.fileType);
    dispatch(_ser.downloaddocumentAsync(JobId, actiontypeToApi, object.id));
  };

  // useEffect(() => {
  //   if (docData) {
  //     if (actionType === "Download" || actionType === "download") {
  //       const link = document.createElement('a');
  //       link.href = docData;
  //       link.download = DocName;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     } else {
  //       setPreviewType(docData)
  //     }
  //     dispatch(_ser.downloaddocumentStartReducer(initalState));
  //   }
  // }, [docData])

  // --- helpers ---
  const parseFilenameFromContentDisposition = (cd) => {
    if (!cd) return null;
    // filename*=UTF-8''... OR filename="..."
    const star = cd.match(/filename\*=(?:UTF-8''|)([^;]+)/i);
    if (star) return decodeURIComponent(star[1].replace(/^"|"$|;/g, ""));
    const norm = cd.match(/filename="?([^"]+)"?/i);
    return norm ? norm[1] : null;
  };

  const guessNameFromUrl = (url) => {
    try {
      return decodeURIComponent(
        new URL(url).pathname.split("/").pop() || "download",
      );
    } catch {
      return "download";
    }
  };

  const forceDownloadFromUrl = async (url, fallbackName = "download") => {
    const res = await fetch(url, { credentials: "omit", cache: "no-store" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const cd = res.headers.get("content-disposition");
    const nameFromHeader = parseFilenameFromContentDisposition(cd);
    const blob = await res.blob();

    const a = document.createElement("a");
    const blobUrl = URL.createObjectURL(blob);
    a.href = blobUrl;
    a.download = nameFromHeader || fallbackName || guessNameFromUrl(url);
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  };

  const forceDownloadFromBlob = (blobOrArrayBuffer, filename = "download") => {
    const blob =
      blobOrArrayBuffer instanceof Blob
        ? blobOrArrayBuffer
        : new Blob([blobOrArrayBuffer]);
    const a = document.createElement("a");
    const href = URL.createObjectURL(blob);
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        if ((actionType || "").toLowerCase() === "download") {
          if (typeof docData === "string") {
            const filename =
              selectedDoc?.fileName || DocName || guessNameFromUrl(docData);
            // force download via Blob
            const res = await fetch(docData, {
              cache: "no-store",
              credentials: "omit",
            });
            const blob = await res.blob();
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            const filename =
              selectedDoc?.fileName ||
              DocName ||
              `document.${(fileExtention || "pdf").toLowerCase()}`;
            const blob =
              docData instanceof Blob ? docData : new Blob([docData]);
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          }
        } else if (actionType === "viewDocumentNewPage") {
          openDocumentInNewTab(docData, fileExtention);
        } else {
          setPreviewType(docData);
        }
      } finally {
        dispatch(_ser.downloaddocumentStartReducer(initalState));
      }
    };

    run();
  }, [docData]);

  useEffect(() => {
    console.log("documents", documents);
  }, [documents]);

  const onReceivePropsHandler = (pannel, load, type) => {
    if (type !== "") {
      setIsRightSidePannel(pannel);
      setIsLoadDoc(load);
    } else {
      DownloadFileFromS3(pannel, load);
    }
  };

  return (
    <>
      <div id="applicantDocs" className="contentSection">
        {documents.length > 0 && (
          <DynamicTable
            config={config}
            data={documents}
            colmns={columnsData}
            actionDropdown={actionsDropdownData}
            actions={actionsList}
            addModel={addNewModel}
            noDataText={"No documents found"}
            searchKeyWord="Search by Document Name"
            onReceiveActionProps={(type, obj) =>
              onReceiveActionHandler(type, obj)
            }
          />
        )}
        {documents.length === 0 && (
          <DynamicTable
            config={config}
            data={documents}
            colmns={columnsData}
            actionDropdown={actionsDropdownData}
            actions={actionsList}
            addModel={addNewModel}
            noDataText={"No documents found"}
            searchKeyWord="Search by Document Name"
            onReceiveActionProps={(type, obj) =>
              onReceiveActionHandler(type, obj)
            }
          />
        )}
      </div>
      {isRightSidePannel ? (
        <AddApplicantDocuments
          HandlerType={HandlerType}
          JobId={JobId}
          previewType={previewType}
          DocName={DocName}
          fileExtention={fileExtention}
          onReceivePropsHandler={onReceivePropsHandler}
        />
      ) : (
        <></>
      )}
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog"
        style={{ marginTop: "-26%" }}
      >
        <Box sx={{ width: "395px" }}>
          <DialogTitle className="diabtn">
            Confirm
            <img
              src={process.env.PUBLIC_URL + "/assests/img/close.svg"}
              alt=""
              className="primaryCloseicon"
              onClick={handleClose}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText className="" id="primary-dialog">
              <p className="btntext">
                Are you sure you want to mark this document as primary?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="alert-actionbtns">
            <Button onClick={handleClose}>
              <Link href="#" color="#000" underline="always">
                Cancel
              </Link>
            </Button>
            <Button onClick={() => handleActionClick(null, "confirm")}>
              Confirm
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default ApplicantDocuments;

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isPaginationTop: false,
  ischeckAlignRight: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ["New Document", "Mark as Primary"];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isPositingsView: true,
  isPostingsDownload: true,
  isDelete: true,
  openNewTab: true,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Document Name",
    mappingName: "name",
    class: "",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center dynatablebodytext",
    isEdit: false,
    nagigate: null,
    width: "25%",
  },
  {
    id: 2,
    displayName: "Uploaded by",
    mappingName: "uploadedBy",
    class: "",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center dynatablebodytext",
    isEdit: false,
    nagigate: null,
    width: "15%",
  },
  {
    id: 3,
    displayName: "Document Type",
    mappingName: "documentType",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center dynatablebodytext",
    isEdit: false,
    nagigate: null,
    width: "15%",
  },
  {
    id: 4,
    displayName: "Sourced from",
    mappingName: "resumesource",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center dynatablebodytext",
    isEdit: false,
    nagigate: null,
    width: "15%",
  },
  {
    id: 5,
    displayName: "Date and Time",
    mappingName: "createdDate",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center documentposttime",
    isEdit: false,
    nagigate: null,
    width: "15%",
  },
  {
    id: 6,
    displayName: "Action",
    mappingName: "Actions",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center documentposttime",
    isEdit: false,
    width: "15%",
    nagigate: null,
    openNewTab: true,
  },
  {
    id: 7,
    displayName: "primaryResume",
    mappingName: "primaryResume",
    theadClass: " text-center dynatableheadtext",
    tbodyClass: " text-center documentposttime",
    isEdit: false,
    width: "",
    nagigate: null,
  },
];

const addNewModel = {
  url: "",
  displayName: "",
};
